import dateFormat from 'dateformat'
import { createNeedFormService } from '../../../search/search-service'
import { getCityNameByCityId, getCityId, cookies } from '../../../../core/utils/index'
import router from '../../../../app-routing'
import { isString } from 'lodash'
import { channelIdList, level4CategoryIdList } from './emun'

export const CITY_COOKIE = 'city_service'

export const channelIdIsSendForm = (channelId: any) => {
  return channelIdList.includes(+channelId)
}

export const level4CategoryIdIsSendForm = (channelId: any) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (channelId) {
    return channelId.split(',').filter((item: string) => level4CategoryIdList.find(items => item == items))
  }
}

//chooseCityFirst是否优先取city  适用于自动收集表单需求取city， 无city信息返回null，不使用默认城市
export async function getSelectedCity(chooseCityFirst = true): Promise<any> {
  const currentRoute = router.currentRoute
  const query = currentRoute.query
  const isSelected = (query && query.swt === '1') || chooseCityFirst
  let cityId = ''
  let cityName = ''
  const cityIdCityName = cookies.get(CITY_COOKIE)
  if (isSelected && cityIdCityName) {
    if (isString(cityIdCityName)) {
      const iNList = cityIdCityName.split('_')
      cityId = iNList[0]
      cityName = iNList[1]
      if (cityId && !cityName) {
        cityName = await getCityNameByCityId(cityId)
      }
      cityName = cityName.replace('市', '')
    }
  } else {
    console.log(222)
    cityId = cookies.get('citycode') || ''
    if (cityId) {
      cityName = await getCityNameByCityId(cityId)
      console.log(cityName, 'cityName')
    }
    cityName = cityName.replace('市', '')
  }
  if (cityId && cityName) {
    cityId = getCityId(cityId)
    return {
      cityId,
      cityName
    }
  } else {
    return null
  }
}

interface FormData {
  categoryId: Array<string>
  utm: string
}

export const creatCollectForm = async (data: FormData) => {
  const city = await getSelectedCity()
  if (cookies.get('uid') && city) {
    // 发送自动收集需求表单接口
    const params = {
      uid: cookies.get('uid'),
      skey: cookies.get('skey'),
      cityId: city.cityId,
      cityName: city.cityName, // 城市name
      createTime: dateFormat(new Date(), 'yyyy-mm-dd HH:MM:ss'),
      content: `非主动提交，话术请不要询问用户是否填写心愿单`, //产品王瑞雨给出的信息
      categoryId: data.categoryId,
      utm: data.utm // 搜索渠道码写死pdss
    }
    return createNeedFormService(params)
  }
}
